<template>
    <div class="address-book">
        <OrgSelectorComponent
            :showGroup="[1,6]"
            :showCheckBox="[]"
            @userClick="onUserClick"
        />
    </div>
</template>

<script>
import OrgSelectorComponent from "@/components/OrgSelector/OrgSelectorComponent"

export default {
    name: 'AddressBook',
    components: {OrgSelectorComponent},
    data() {
        return {}
    },
    computed: {},
    methods: {
        onUserClick(user) {
            this.$router.push({path: '/addressBook/userDetail', query: {uuid: user.uuid}})
        }
    },
}
</script>
